import { Controller } from "@hotwired/stimulus"

// Превью выбранных изображений с возможностью добавления и удаления файлов.
// Источник истины — DataTransfer; из него же переустанавливается input.files,
// поэтому на сервер уходит ровно то, что показано в превью.
export default class extends Controller {
  static targets = ["input", "previews", "submit"]

  connect() {
    this.dt = new DataTransfer()
    this.render()
  }

  disconnect() {
    this.dt = null
  }

  // Открыть системный выбор файлов (накопительное добавление).
  openPicker() {
    this.inputTarget.click()
  }

  // Сработало при выборе файлов в input — добавляем новые к уже выбранным.
  filesAdded() {
    for (const file of this.inputTarget.files) {
      if (!this.isDuplicate(file)) this.dt.items.add(file)
    }
    this.syncInput()
  }

  // Удалить файл по индексу (data-file-previews-index-param).
  remove(event) {
    const index = Number(event.params.index)
    const next = new DataTransfer()
    Array.from(this.dt.files).forEach((file, i) => {
      if (i !== index) next.items.add(file)
    })
    this.dt = next
    this.syncInput()
  }

  isDuplicate(file) {
    return Array.from(this.dt.files).some(
      (f) =>
        f.name === file.name &&
        f.size === file.size &&
        f.lastModified === file.lastModified
    )
  }

  syncInput() {
    this.inputTarget.files = this.dt.files
    this.render()
  }

  render() {
    const files = Array.from(this.dt.files)
    this.previewsTarget.innerHTML = ""

    files.forEach((file, index) => {
      const col = document.createElement("div")
      col.className = "col-6 col-md-3"

      const card = document.createElement("div")
      card.className = "card h-100"

      const img = document.createElement("img")
      img.className = "card-img-top"
      img.style.height = "120px"
      img.style.objectFit = "contain"
      img.alt = file.name
      this.readImage(file, img)

      const body = document.createElement("div")
      body.className = "card-body p-2 d-flex justify-content-between align-items-center gap-2"

      const name = document.createElement("small")
      name.className = "text-truncate"
      name.title = file.name
      name.textContent = file.name

      const removeBtn = document.createElement("button")
      removeBtn.type = "button"
      removeBtn.className = "btn btn-sm btn-outline-danger flex-shrink-0"
      removeBtn.textContent = "×"
      removeBtn.setAttribute("aria-label", "Удалить файл")
      removeBtn.dataset.action = "file-previews#remove"
      removeBtn.dataset.filePreviewsIndexParam = index

      body.append(name, removeBtn)
      card.append(img, body)
      col.append(card)
      this.previewsTarget.append(col)
    })

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = files.length === 0
    }
  }

  readImage(file, img) {
    const reader = new FileReader()
    reader.onload = (e) => {
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }
}
